import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const popupInwardStockDetail = defineAsyncComponent(() =>
  import('@/views/asset/inwardStock/InwardStockDetail.vue'),
);
const popupOutwardStockDetail = defineAsyncComponent(() => import('@/views/asset/outwardStock/OutwardStockDetail.vue'));

// chuyển kho
const popupAssetTransferDetail = defineAsyncComponent(() =>
  import('@/views/asset/assetTransfer/AssetTransferDetail.vue'),
);
// kiểm kê
const popupInventoryDetail = defineAsyncComponent(() =>
  import('@/views/asset/inventory/InventoryDetail.vue'),
);

export function registerAsset(app) {
    app.component('InwardStockDetail', popupInwardStockDetail);
    app.component('OutwardStockDetail', popupOutwardStockDetail);
    app.component('AssetTransferDetail', popupAssetTransferDetail);
    app.component('InventoryDetail', popupInventoryDetail);
}
